type StructuredDataProps = {
  data: unknown;
};

/**
 * Renders Schema.org JSON-LD as a plain element inside the page body.
 * React keeps a single node and updates it in place when the data changes
 * (for example when the visitor switches language), so the page never ends
 * up with two structured-data blocks for the same entity.
 */
export default function StructuredData({ data }: StructuredDataProps) {
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
